/* @flow */
import * as React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  className?: any,
  src?: any,
  controls?: boolean,
};

const Video = React.forwardRef(
  ({ className, src, controls = true, ...restProps }: Props, ref): React$Element<any> => {
    return (
      <video
        ref={ref}
        className={classNames(styles.video, className)}
        controls={controls}
        {...restProps}
      >
        <source src={src} type="video/mp4" />
      </video>
    );
  }
);

export default Video;
